import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {SelfAssessmentService} from "../self-assessment.service";
import {AppState} from "../../../store";
import {Store} from "@ngrx/store";
import {getSelfAssessedRequirements} from "../../../store/selectors/user.selector";
import {SelfAssessedReqRow} from "../../../interfaces/self-assessed-req-row";
import {
  clearAllSelfAssessedRequirements,
  clearSelfAssessedBicId, resetSelfAssessedRequirementsTimeout,
  updateSelfAssessedRequirementsTimeout
} from "../../../store/actions/user.actions";
import {Overlayable} from "../../../interfaces/overlayable";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {Router} from "@angular/router";
import {ProfessionsService} from "../../../services/professions.service";

@UntilDestroy()
@Component({
  selector: 'brt-self-assessment-footer',
  templateUrl: './self-assessment-footer.component.html',
  styleUrls: ['./self-assessment-footer.component.scss']
})
export class SelfAssessmentFooterComponent implements OnInit, Overlayable, OnDestroy {
  onClosed = new EventEmitter<boolean>();
  isFirst = true;
  isLast = false;
  currentPage = 0;
  currentPageSelfAssessmentsActiveNumber = 0;
  currentUserSelfAssessedRequirements: SelfAssessedReqRow[] = [];

  currentPageToBicIdMap = new Map<number, number>([[1, 1], [2,2], [3,3], [4,4], [5,6]]);

  userSavedResults = false;
  constructor(private selfAssessment: SelfAssessmentService, private store: Store<AppState>, private router: Router, private professionsService: ProfessionsService) {
  }

  ngOnInit() {
    this.selfAssessment.onCurrentPageNumberChanged().pipe(untilDestroyed(this)).subscribe((val) => {
      this.currentPage = val;
      this.isFirst = val === 1;
      this.isLast = val === this.selfAssessment.totalPageNumber;
      console.log(val, this.selfAssessment.totalPageNumber);
      this.updateCurrentPageSelfAssessmentsActiveNumber(this.currentUserSelfAssessedRequirements, this.currentPage);
    });

    this.store.select(getSelfAssessedRequirements()).pipe(untilDestroyed(this)).subscribe((val) => {
      this.currentUserSelfAssessedRequirements = val;
      this.updateCurrentPageSelfAssessmentsActiveNumber(this.currentUserSelfAssessedRequirements, this.currentPage);

    })
  }

  updateCurrentPageSelfAssessmentsActiveNumber(selfAssessedReqRows: SelfAssessedReqRow[], currentPage: number) {
    const targetBicIDByPage = this.currentPageToBicIdMap.get(this.currentPage) ?? 1;
    const currentPageRow = selfAssessedReqRows.filter((el) => el.bicId === targetBicIDByPage);
    if(currentPageRow.length) {
      this.currentPageSelfAssessmentsActiveNumber = currentPageRow[0].reqIds.length;
    } else {
      this.currentPageSelfAssessmentsActiveNumber = 0;
    }
  }

  goPrev() {
    this.selfAssessment.setPreviousPageNumber();
  }
  goNext() {
    this.selfAssessment.setNextPageNumber()
  }

  endAssessment() {
    this.userSavedResults = true;
    this.onClosed.emit(true);
    this.store.dispatch(updateSelfAssessedRequirementsTimeout());
    this.router.navigateByUrl('/' + this.professionsService.getFilterUrl(1, [], "", [], "matching-desc", false, [], []), {
      onSameUrlNavigation: "reload"
    });
  }

  clearPage() {
    this.store.dispatch(clearSelfAssessedBicId({bicId: this.currentPage}));

    (window.document.activeElement as HTMLElement).blur();
    (window.document.querySelector(".self-assessment__option:last-child button") as HTMLElement).focus();
  }

  ngOnDestroy() {
    if(!this.userSavedResults) { // this flag will be true if user call endAssessment function, otherwise false
      this.store.dispatch(clearAllSelfAssessedRequirements());
      this.store.dispatch(resetSelfAssessedRequirementsTimeout());
    }
  }
}
